<template>
  <Dropdown
    :trigger="'hover'"
    :gap="[16, 16]"
    :content-style="{ zIndex: 10000 }"
    position="bottomCenter"
    v-if="!isUS()"
  >
    <template #trigger>
      <slot />
    </template>
    <template #content>
      <div class="authorization-differences" :class="{ 'non-arrow': nonArrow }">
        <div v-for="(item, i) in data" :key="item.name" :class="['diff', `diff-${i}`]">
          <h2>{{ item.name }}</h2>
          <p class="desc">{{ item.desc }}</p>

          <div v-if="item.scenes.length" class="mb-[12px]">
            <p class="desc-title">{{ $t('shi-he-yi-xia-chang-jing') }}</p>
            <span v-for="tag in item.scenes" class="tag" :key="tag"> # {{ tag }} </span>
          </div>

          <div v-if="item.disScenes.length">
            <p class="desc-title">{{ $t('bu-shi-he-yi-xia-chang-jing') }}</p>
            <span v-for="tag in item.disScenes" class="tag red" :key="tag"> # {{ tag }} </span>
          </div>

          <div v-show="item.isTip" class="tip">
            {{
              $t(
                'ru-guo-ni-shi-qi-ye-yuan-gong-mei-ti-cong-ye-zhe-zhi-zuo-de-shi-pin-shou-yi-fang-shi-qi-ye-gong-zuo-shi-qing',
              )
            }}
            <span class="tip-bold" @click="handleSubscribe">
              {{ $t('xuan-ze-qi-ye-shang-yong-ban') }}
            </span>
            ！
          </div>
        </div>
      </div>
    </template>
  </Dropdown>
</template>
<script lang="ts" setup>
import { getI18nService } from '@rendora/common/services/i18n';
import { isUS } from '@rendora/common/utils/config';
import { Dropdown } from '@rendora/design/components/dropdown/index';
import { ref } from 'vue';
import { showRightCompareModal } from './right-compare';
defineProps<{ nonArrow?: boolean }>();
const i18nService = getI18nService();
const $t = i18nService.t;
const data = ref([
  {
    name: $t('ge-ren-shang-yong-shou-quan'),
    desc: $t(
      'ge-ren-shang-yong-shou-quan-chan-pin-ji-shi-pin-jin-xian-yong-yu-yi-ge-ren-wei-zhu-ti-cong-shi-de-shang-shi-huo-dong-zhong-qie-bao-zheng-ying-li-ji-zui-zhong-de-shou-yi-zhu-ti-wei-ge-ren',
    ),
    scenes: [
      $t('ge-ren-xin-mei-ti-zhang-hao'),
      $t('ge-ren-wang-zhan'),
      $t('ge-ti-shang-pu'),
      $t('ge-ren-zhi-bo-dai-huo'),
    ],
    disScenes: [
      $t('qi-ye-gong-zhong-hao-mei-ti-zhang-hao'),
      $t('qi-ye-nei-pei'),
      $t('qi-ye-zhi-bo-dai-huo'),
      $t('qi-ye-xian-shang-xian-xia-tui-guang'),
    ],
  },
  {
    name: $t('qi-ye-shang-yong-shou-quan'),
    desc: $t(
      'qi-ye-shang-yong-shou-quan-chan-pin-ji-shi-pin-ke-yi-zai-qi-ye-zhu-ti-de-mei-ti-zhang-hao-zhong-fa-bu-wei-qi-ye-zuo-xuan-chuan-tui-guang-qi-ye-fa-bu-hui-pei-xun-hui-deng-shang-shi-huo-dong',
    ),
    scenes: [
      $t('qi-ye-gong-zhong-hao-mei-ti-zhang-hao'),
      $t('qi-ye-nei-pei'),
      $t('qi-ye-zhi-bo-dai-huo'),
      $t('qi-ye-xian-shang-xian-xia-tui-guang'),
    ],
    disScenes: [],
    isTip: true,
  },
]);

const handleSubscribe = () => {
  showRightCompareModal();
};
</script>
<style lang="scss" scoped>
.authorization-differences {
  display: flex;
  padding: 12px;
  background-color: var(--x-back-1);
  position: relative;
  box-shadow: var(--x-shadow);
  border-radius: var(--x-radius-medium);
  gap: 12px;
  border: 1px solid var(--x-back-4);

  // outer border triangle
  &:not(.non-arrow)::before {
    content: '';
    position: absolute;
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid var(--x-back-4);
  }
  // inner fill triangle
  &:not(.non-arrow)::after {
    content: '';
    position: absolute;
    top: -9px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 9px solid transparent;
    border-right: 9px solid transparent;
    border-bottom: 9px solid var(--x-back-1);
  }
}
.diff {
  width: 288px;
  padding: 20px;
  border-radius: var(--x-radius-medium);
  border: 1px solid var(--x-back-4);

  .desc {
    margin-bottom: 20px;
    font-size: 12px;
    line-height: 24px;
    color: var(--x-text-5);
  }

  .desc-title,
  h2 {
    font-weight: var(--x-weight-medium);
    font-size: 14px;
    color: var(--x-text-1);
    line-height: 20px;
    margin-top: 0;
    margin-bottom: 8px;
  }

  .tip {
    font-size: 12px;
    color: var(--x-text-1);
    line-height: 21px;
  }

  .tip-bold {
    cursor: pointer;
    font: bold;
    text-decoration: underline;
    color: var(--x-purple-6);
  }
}
.tag {
  padding: 5px 12px;
  font-size: 12px;
  border-radius: var(--x-radius-medium);
  border: 1px solid var(--x-purple-3);
  color: var(--x-purple-6);
  display: inline-block;
  font-weight: 400;

  &:not(:last-child) {
    margin-bottom: 8px;
    margin-right: 8px;
  }
  &.red {
    border: 1px solid var(--x-error-3);
    color: var(--x-error-7);
  }
}
</style>
